import React from 'react';
import HomePage from './pages/index';
import './index.css';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
